(() => {
  const isQuestionnairePage = () => /\/pages\/questionnaire\b/.test(window.location.pathname) || document.querySelector('.qhead, .stage, .qfoot');
  const CONSISTENCY_BAD = 'What usually makes it hard to stay consistentWhat usually gets in the way of your progress?';
  const CONSISTENCY_GOOD = 'What usually gets in the way of your progress?';
  let reviewCheckoutSubmitting = false;
  let renderCleanQueued = false;

  const textReplacements = [
    [CONSISTENCY_BAD, CONSISTENCY_GOOD],
    ['e.g. HassaLast name', 'Last name'],
    ['One-Time Workout — THB 1,500', 'One-Time Workout — THB 1,000'],
    ['One-Time Nutrition — THB 1,000', 'One-Time Nutrition — THB 1,500'],
    ['One-Time Workout - THB 1,500', 'One-Time Workout - THB 1,000'],
    ['One-Time Nutrition - THB 1,000', 'One-Time Nutrition - THB 1,500']
  ];

  const cleanString = (value) => {
    if (typeof value !== 'string') return value;
    let next = value
      .replace(/Let's build\s+<span/g, "Let's build <span")
      .replace(/class=\"amber\">\s+/g, 'class="amber">');
    for (const [from, to] of textReplacements) next = next.split(from).join(to);
    return next;
  };

  const setPlan = (plan, price, priceLabel, variantId) => {
    if (!plan) return;
    plan.price = price;
    plan.priceLabel = priceLabel;
    plan.variantId = variantId;
  };

  const cleanConfig = () => {
    const config = window.TST_CONFIG;
    if (!config) return;

    if (config.welcome && typeof config.welcome.headline === 'string') config.welcome.headline = cleanString(config.welcome.headline);

    if (Array.isArray(config.plans)) {
      config.plans.forEach((plan) => {
        if (!plan) return;
        if (plan.id === 'start') setPlan(plan, '4,500', 'THB 4,500', '48606679924968');
        if (plan.id === 'progress') setPlan(plan, '11,500', 'THB 11,500', '48606679957736');
        if (plan.id === 'transformation') setPlan(plan, '22,500', 'THB 22,500', '48606679990504');
        if (plan.id === 'workout-only') setPlan(plan, '1,000', 'THB 1,000', '48606680023272');
        if (plan.id === 'nutrition-only') setPlan(plan, '1,500', 'THB 1,500', '48606680056040');
      });
    }

    if (Array.isArray(config.questions)) {
      config.questions.forEach((question) => {
        if (!question) return;
        question.label = cleanString(question.label);
        question.sub = cleanString(question.sub);
        question.placeholder = cleanString(question.placeholder);

        if (question.type === 'textarea') {
          const fieldIdLooksLikeCopy = typeof question.fieldId === 'string' && /^(Example:|e\.g\.)/i.test(question.fieldId.trim());
          const fieldIdLooksUnsafe = typeof question.fieldId !== 'string' || /\s/.test(question.fieldId);
          if (fieldIdLooksLikeCopy || fieldIdLooksUnsafe) question.fieldId = question.id;
        }

        if (Array.isArray(question.fields)) {
          question.fields.forEach((field) => {
            if (!field) return;
            field.label = cleanString(field.label);
            field.placeholder = cleanString(field.placeholder);
            if (question.id === 'nutrition-details') {
              if (/normal day/i.test(field.label || '')) field.id = 'typical';
              if (/allergies|restrictions/i.test(field.label || '')) field.id = 'allergies';
            }
          });
        }
      });
    }

    try { if (window.TST_PURCHASE_PATH) window.TST_PURCHASE_PATH.refresh(); } catch (error) {}
  };

  const replaceTextNodes = (root = document.body) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const cleaned = cleanString(node.nodeValue);
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }
  };

  const cleanInputs = (root = document.body) => {
    if (!root) return;
    root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((field) => {
      const cleaned = cleanString(field.getAttribute('placeholder'));
      if (cleaned !== field.getAttribute('placeholder')) field.setAttribute('placeholder', cleaned);
    });
  };

  const isReviewStep = () => {
    try { return typeof currentQ === 'function' && currentQ() && currentQ().type === 'review'; } catch (error) { return false; }
  };

  const plainLabel = (value) => String(value || '').replace(/<[^>]+>/g, '').trim();

  const getPlans = () => {
    try { if (typeof PLANS !== 'undefined' && Array.isArray(PLANS)) return PLANS; } catch (error) {}
    return window.TST_CONFIG && Array.isArray(window.TST_CONFIG.plans) ? window.TST_CONFIG.plans : [];
  };

  const selectedPlan = () => {
    try {
      const key = (typeof STATE !== 'undefined' && STATE.plan) || (window.TST_PURCHASE_PATH && window.TST_PURCHASE_PATH.selectedPlanKey());
      return getPlans().find((plan) => plan && plan.id === key) || (key && window.TST_PURCHASE_PATH && window.TST_PURCHASE_PATH.plans[key]);
    } catch (error) { return null; }
  };

  const goToPlanStep = () => {
    try {
      const questions = typeof activeQuestions === 'function' ? activeQuestions() : [];
      const planIndex = questions.findIndex((question) => question && question.type === 'plan-select');
      if (planIndex < 0) { window.location.href = '/#programs'; return; }
      STATE.lastDir = 'back';
      STATE.idx = planIndex;
      if (typeof saveState === 'function') saveState();
      if (typeof renderCard === 'function') renderCard();
      queueRenderedCleanup();
    } catch (error) {
      console.warn('[TST] Could not return to plan selection', error);
      window.location.href = '/pages/questionnaire';
    }
  };

  const answerValue = (question, answers) => {
    if (!question) return '';
    if (question.type === 'compound' && Array.isArray(question.fields)) {
      return question.fields.map((field) => (answers[field.id] ? `${plainLabel(field.label || field.id)}: ${answers[field.id]}` : '')).filter(Boolean).join('\n');
    }
    if (question.type === 'body-stats') {
      const unit = answers.bodyUnit || 'metric';
      if (!answers.height && !answers.weight) return '';
      return `Height: ${answers.height || ''}${unit === 'metric' ? ' cm' : ''}\nWeight: ${answers.weight || ''}${unit === 'metric' ? ' kg' : ' lb'}`;
    }
    if (question.type === 'agreement' && Array.isArray(question.agreements)) {
      return question.agreements.map((agreement) => `${plainLabel(agreement.text || agreement.id)}: ${answers[agreement.id] ? 'Yes' : 'No'}`).join('\n');
    }
    if (question.type === 'textarea') return answers[question.fieldId] || '';
    const value = answers[question.id];
    if (Array.isArray(value)) return value.join(', ');
    return value || '';
  };

  const buildSubmissionBody = () => {
    const answers = (typeof STATE !== 'undefined' && STATE.answers) || {};
    const plan = selectedPlan();
    const lines = ['=== THE STRENGTH THEORY - Questionnaire Submission ===', `Submitted: ${new Date().toString()}`, ''];
    if (plan) lines.push(`PLAN: ${(plan.tag || plan.label || '').trim()} - ${(plan.name || '').trim()} (${plan.priceLabel || ''})`, '');
    try {
      const questions = typeof QUESTIONS !== 'undefined' && Array.isArray(QUESTIONS) ? QUESTIONS : [];
      questions.forEach((question) => {
        if (!question || ['welcome', 'complete', 'plan-select', 'review'].includes(question.type)) return;
        const value = answerValue(question, answers);
        if (!value) return;
        if (question.type === 'compound' || question.type === 'body-stats' || question.type === 'agreement') lines.push(value); else lines.push(`${plainLabel(question.label || question.id)}: ${value}`);
      });
    } catch (error) { console.warn('[TST] Could not format all questionnaire answers', error); }
    try { lines.push('', '=== Raw JSON ===', JSON.stringify({ plan: STATE.plan, answers }, null, 2)); } catch (error) {}
    return lines.join('\n');
  };

  const checkoutProperties = () => {
    const answers = (typeof STATE !== 'undefined' && STATE.answers) || {};
    return {
      Name: `${answers.firstName || ''} ${answers.lastName || ''}`.trim(),
      Email: answers.email || '',
      Phone: answers.phone || '',
      Language: answers.language || '',
      Country: answers.country || '',
      'Plan picked': (typeof STATE !== 'undefined' && STATE.plan) || '',
      'Submitted at': new Date().toISOString()
    };
  };

  const sendQuestionnaireAnswers = async () => {
    const answers = (typeof STATE !== 'undefined' && STATE.answers) || {};
    const config = window.TST_CONFIG || {};
    const name = `${answers.firstName || ''} ${answers.lastName || ''}`.trim() || 'Anonymous';
    const email = answers.email || config.fallbackEmail || 'no-reply@example.com';
    const formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[name]', name);
    formData.append('contact[email]', email);
    formData.append('contact[phone]', answers.phone || '');
    formData.append('contact[subject]', `New Questionnaire - ${name}`);
    formData.append('contact[body]', buildSubmissionBody());
    try { await fetch('/contact', { method: 'POST', body: formData, credentials: 'same-origin' }); } catch (error) { console.warn('[TST] contact form submission failed before checkout', error); }
  };

  const directReviewCheckout = async () => {
    if (reviewCheckoutSubmitting) return;
    const plan = selectedPlan();
    const key = plan && plan.id || (window.TST_PURCHASE_PATH && window.TST_PURCHASE_PATH.selectedPlanKey());
    if (!key) { goToPlanStep(); return; }
    reviewCheckoutSubmitting = true;
    const nextButton = document.getElementById('btn-next');
    if (nextButton) nextButton.disabled = true;
    if (typeof saveState === 'function') saveState();
    await sendQuestionnaireAnswers();
    if (window.TST_PURCHASE_PATH && typeof window.TST_PURCHASE_PATH.startCheckout === 'function') {
      window.TST_PURCHASE_PATH.startCheckout(key, { source: 'questionnaire-complete', properties: checkoutProperties() });
      return;
    }
    reviewCheckoutSubmitting = false;
    if (nextButton) nextButton.disabled = false;
    alert('Checkout is still loading. Please try again.');
  };

  const bindReviewSubmitCheckout = () => {
    const nextButton = document.getElementById('btn-next');
    if (!nextButton || nextButton.dataset.tstReviewCheckoutBound === '2') return;
    nextButton.dataset.tstReviewCheckoutBound = '2';
    nextButton.addEventListener('click', (event) => {
      if (!isReviewStep()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      directReviewCheckout();
    }, true);
  };

  const injectReviewActionStyles = () => {
    if (document.getElementById('tst-review-plan-action-styles')) return;
    const style = document.createElement('style');
    style.id = 'tst-review-plan-action-styles';
    style.textContent = '.review__plan-actions{display:flex;flex-wrap:wrap;gap:10px;margin:-12px 0 24px}.review__plan-action{min-height:44px;display:inline-flex;align-items:center;justify-content:center;padding:10px 16px;border-radius:999px;border:1px solid rgba(241,236,224,.3);background:rgba(241,236,224,.06);color:var(--c-bone,#f1ece0);font-size:11px;font-weight:800;letter-spacing:.06em;line-height:1.15;text-align:center;text-transform:uppercase;text-decoration:none;cursor:pointer;white-space:normal}.review__plan-action:hover,.review__plan-action:focus-visible{border-color:var(--c-amber,#e97826);outline:none}.review__plan-action--primary{background:var(--c-bone,#f1ece0);border-color:var(--c-bone,#f1ece0);color:var(--c-charcoal,#0e0e0d)}@media (max-width:760px){.review__plan-actions{display:grid;grid-template-columns:1fr;gap:8px;margin:-8px 0 20px}.review__plan-action{width:100%;min-height:46px;padding:11px 14px;font-size:10px}}';
    document.head.appendChild(style);
  };

  const addReviewPlanActions = (root = document.body) => {
    const review = root && root.querySelector ? root.querySelector('.review') : null;
    if (!review || review.querySelector('.review__plan-actions')) return;
    const selectedPlanEl = review.querySelector('.review__plan');
    if (!selectedPlanEl) return;
    injectReviewActionStyles();
    const actions = document.createElement('div');
    actions.className = 'review__plan-actions';
    actions.innerHTML = '<button class="review__plan-action review__plan-action--primary" type="button" data-review-change-plan>Change selected plan</button><a class="review__plan-action" href="/#programs">Back to packages</a>';
    selectedPlanEl.insertAdjacentElement('afterend', actions);
    const changePlan = actions.querySelector('[data-review-change-plan]');
    if (changePlan) changePlan.addEventListener('click', goToPlanStep);
  };

  const cleanRenderedPage = () => {
    if (!isQuestionnairePage()) return;
    const appRoot = document.querySelector('.stage, .app, .tst-app, main') || document.body;
    replaceTextNodes(appRoot);
    cleanInputs(appRoot);
    bindReviewSubmitCheckout();
    addReviewPlanActions(appRoot);
  };

  function queueRenderedCleanup() {
    if (renderCleanQueued) return;
    renderCleanQueued = true;
    requestAnimationFrame(() => {
      renderCleanQueued = false;
      cleanConfig();
      cleanRenderedPage();
    });
  }

  const runSoon = () => {
    cleanConfig();
    queueRenderedCleanup();
    setTimeout(queueRenderedCleanup, 80);
    setTimeout(queueRenderedCleanup, 280);
  };

  cleanConfig();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runSoon); else runSoon();
  window.addEventListener('load', runSoon);
  document.addEventListener('shopify:section:load', runSoon);
  document.addEventListener('click', runSoon, true);
  document.addEventListener('change', runSoon, true);
})();
